import Container from "./container";
import "../../index.css";

function App() {
  return <Container />;
}

export default App;
